module.exports = __webpack_public_path__ + "img/buddy_whiskers-05.b41f9d71.svg";